<template>
  <tbody>
    <tr class="is-border-top">
      <td class="has-text-centered">
        <avatar
          v-if="displayCompany"
          :use-picto-custom="'fas fa-city'"
          :is-avatar="false"
          :use-picto="'fas fa-city'"
          :item="a.account"
          class="has-background-grey-light is-medium has-text-white">
        </avatar>
        <avatar
          v-if="displayProgram"
          :use-picto-custom="'fas fa-city'"
          :is-avatar="false"
          :use-picto="'fas fa-city'"
          :item="a.program"
          class="has-background-grey-light is-medium has-text-white">
        </avatar>
      </td>
      <td v-if="isPromoteur && displayCompany">
        <router-link :to="{name: 'CompanyVue', params: {id: a.account.pk}}">
          {{ a.account.name | truncate }}
        </router-link>
      </td>
      <td v-else-if="!isPromoteur && displayCompany">
        <router-link :to="{name: 'CompanyVue', params: {id: a.account.pk}}">
          {{ a.promoteur.name | truncate }}
        </router-link>
      </td>
      <td v-if="displayProgram">
        <router-link :to="{name: 'ProgramVue', params: {id: a.program.pk}}">
          {{ a.program.name }}
        </router-link>
      </td>
      <td>{{ a.start_date | date }}</td>
      <td>{{ a.end_date | date }}</td>
      <td class="is-narrow">
        <span
          v-if="filteredAllotments.length"
          class="tag is-allotement is-uppercase">
          {{ filteredAllotments.length }} {{ 'Lot' | pluralize(filteredAllotments.length > 1) }} {{ 'Alloté' | pluralize(filteredAllotments.length > 1) }}
        </span>
      </td>
      <td
        class="is-paddingless is-marginless"
        style="width: 250px;"
        v-if="isPromoteur">
        <div class="field has-addons is-border-left">
          <div class="control is-expanded has-incrementations">
            <span
              class="input is-borderless is-medium is-padding-top-small has-text-centered is-fullwidth">
              {{ a.remuneration }}
            </span>
          </div>
          <div class="control">
            <a class="button is-static is-borderless is-square is-medium">
              <span class="icon"><i class="fas fa-percentage"></i></span>
            </a>
          </div>
          <div
            class="dropdown is-hoverable is-right"
            v-if="!editRem && !editAccess && !loading">
            <div class="dropdown-trigger">
              <button
                class="button is-square is-medium is-radiusless is-borderless"
                aria-haspopup="true"
                aria-controls="dropdown-menu">
                <i class="fal fa-ellipsis-v"></i>
              </button>
            </div>
            <div
              v-if="!a.sales_channel"
              class="dropdown-menu"
              role="menu">
              <div class="dropdown-content has-text-left">
                <a
                  v-if="isPromoteur"
                  class="dropdown-item"
                  @click="selectEditedAccess">
                  <span class="icon is-size-5"><i class="fas fa-edit"></i></span>
                  <span class="is-margin-left-xsmall">Modifier mandat</span>
                </a>
                <a
                  class="dropdown-item has-background-danger has-text-white"
                  @click="deleteAccess">
                  <span class="icon is-size-5"><i class="fas fa-trash-alt"></i></span>
                  <span class="is-margin-left-xsmall">Supprimer mandat</span>
                </a>
              </div>
            </div>
            <div
              v-else
              class="dropdown-menu"
              role="menu">
              <div class="dropdown-content has-text-left">
                <a
                  v-if="isPromoteur"
                  class="dropdown-item"
                  @click="redirectChannel(a.sales_channel.pk)">
                  <span class="icon is-size-5"><i class="fas fa-eye"></i></span>
                  <span class="is-margin-left-xsmall">Voir le canal</span>
                </a>
              </div>
            </div>
          </div>
          <div
            class="control"
            v-if="editRem && !loading">
            <a
              id="submitRemunerationAccess"
              class="button is-square is-medium is-success is-min-width-0 has-hover-black"
              @click="updateAccess">
              <span class="icon is-size-5"><i class="fas fa-save"></i></span>
            </a>
          </div>
          <div
            class="control"
            v-if="(editRem || editAccess) && !loading">
            <a
              class="button is-square is-medium is-draft is-min-width-0"
              @click="cancelEditAccess">
              <span class="icon is-size-5 has-text-white"><i class="fas fa-times"></i></span>
            </a>
          </div>
          <div
            class="control"
            v-if="loading">
            <button class="button is-square is-medium is-primary is-min-width-0 has-hover-black is-loading">
              <span class="icon"><i class="fas fa-lg fa-spinner-third"></i></span>
            </button>
          </div>
        </div>
      </td>
      <td
        class=""
        style="width: 250px;"
        v-else>
        {{ a.remuneration }} %
      </td>
    </tr>
    <tr v-if="editAccess">
      <td
        colspan="7"
        class="box3 is-paddingless">
        <access-form
          :access-pk="source.pk"
          :source-access="source"
          :source-account="source.account.pk"
          :source-program-lots="lots"
          :source-allotments="filteredAllotments"
          :accesses="accesses"
          :program="program || a.program"
          @updateAccess="updateAccessAllotment"></access-form>
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep, debounce } from 'lodash'

export default {
  name: 'AccessLightListItem',
  components: {
    AccessForm: () => import('@/components/access/AccessForm')
  },
  props: {
    allotments: Array,
    accesses: Array,
    programLots: Array,
    source: Object,
    program: [Object, String],
    lots: Array,
    promoteur: [Object, String],
    company: [Object, String],
    loadingAccess: Boolean,
    selectedAccess: String
  },
  data () {
    return {
      a: null,
      savedAccess: null,
      editAccess: false,
      editRem: false
      // canUpdateAccess: true
    }
  },
  computed: {
    ...mapGetters(['isPromoteur']),
    /**
      * filter allotments by access
      * @returns {Array}
      */
    filteredAllotments () {
      let result = null
      if (this.source.account) {
        result = this.allotments.filter(x => this.source.pk.includes(x.access))
      } else if (this.source.accounts) {
        result = this.allotments.filter(x => this.source.pk.includes(x.mandat))
      }
      return result
    },
    /**
      * is loading
      * @returns {boolean}
      */
    loading () {
      return this.loadingAccess && this.selectedAccess === this.a.pk
    },
    /**
      * display company if route isn't relation
      * @returns {boolean}
      */
    displayCompany () {
      return !this.$route.path.split('/').includes('relations') && !this.$route.path.split('/').includes('societes')
    },
    /**
      * display program if route isn't program
      * @returns {boolean}
      */
    displayProgram () {
      return !this.$route.path.split('/').includes('programmes')
    }
  },
  watch: {
    source (v) {
      this.a = v
      this.savedAccess = cloneDeep(v)
      this.editAccess = false
      this.editRem = false
    },
    selectedAccess (v) {
      if (v !== this.a.pk) {
        this.cancelEditAccess()
      }
    }
  },
  created () {
    if (this.source) {
      this.editAccess = false
      this.editRem = false
      this.a = this.source
      this.savedAccess = cloneDeep(this.source)
    }
  },
  methods: {
    /**
      * select edit Access
      */
    selectEditedAccess () {
      this.editAccess = true
      this.$emit('selectedAccess', this.a.pk)
    },
    /**
      * edit remuneration
      */
    selectEditedRem: debounce(function () {
      this.editRem = true
      this.$emit('selectedAccess', this.a.pk)
    }, 400),
    /**
      * update access allotment
      * @param {object}
      */
    updateAccessAllotment (access) {
      this.$emit('updateAccessAllotment', access)
    },
    /**
      * update access
      */
    updateAccess () {
      this.editAccess = false
      this.editRem = false
      this.$emit('updateAccess', this.a)
    },
    /**
      * cancel edit access
      */
    cancelEditAccess () {
      this.editAccess = false
      this.editRem = false
      this.a = cloneDeep(this.savedAccess)
    },
    /**
      * emit delete access
      */
    deleteAccess () {
      this.$emit('deleteAccess', this.a.pk)
    },
    // askSubmit () {
    //   this.$refs.accessForm.submit()
    // },
    /**
      * select input
      * @param {string}
      */
    selectInput (input) {
      if (input in this.$refs) {
        if (Array.isArray(this.$refs[input])) {
          this.$refs[input][0].select()
        } else {
          this.$refs[input].select()
        }
      }
    },
    redirectChannel (id) {
      this.$router.push({ name: 'ChannelVue', params: { id } })
    }
  }
}
</script>
